import * as angular from 'angular';

import { IDispatcherService, IDispatcher, } from '..';
import { IUserGroupActionsService as IUserGroupActionsService } from './userGroups.actionCreator';
import { UserGroups } from '../../models';

export interface IUserGroupsStoreService {
    getAll: (force?: boolean) => angular.IPromise<UserGroups[]>;
    updateOne: (target: UserGroups) => angular.IPromise<UserGroups[]>;
    deleteOne: (target: UserGroups) => angular.IPromise<UserGroups>;
}

export interface IUserGroupsActionDispatcherService extends IDispatcherService<IUserGroupsStoreService> { }

export class UserGroupssActionDispatcherService implements IUserGroupsActionDispatcherService {
    static serviceId = 'userGroupsActionDispatcherService';

    static $inject = ['userGroupActionsService'];

    constructor(private _actionService: IUserGroupActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IUserGroupsStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force)),
                updateOne: (target: UserGroups) => dispatch(this._actionService.updateOne(target)),
                deleteOne: (target: UserGroups) => dispatch(this._actionService.deleteOne(target)),
            }
        };
    }
}